import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";
import { AMMESSI, ESCLUSI } from "@/pages/rc/eligibilityReference";
import { ShieldQuestion, ShieldCheck, Ban } from "lucide-react";

export const EligibilityDialog = () => (
  <Dialog>
    <DialogTrigger asChild>
      <Button data-testid="eligibility-help-btn" variant="outline" size="sm" className="rounded-sm">
        <ShieldQuestion className="w-4 h-4 mr-1.5" strokeWidth={1.5} /> Chi può assicurarsi?
      </Button>
    </DialogTrigger>
    <DialogContent className="max-w-lg">
      <DialogHeader>
        <DialogTitle>Ammissibilità RC Economia Solidale</DialogTitle>
        <DialogDescription>Verifica rapida prima di procedere col preventivo.</DialogDescription>
      </DialogHeader>
      <div className="space-y-5 max-h-[60vh] overflow-y-auto pr-1">
        <div>
          <div className="flex items-center gap-2 text-emerald-700 mb-2">
            <ShieldCheck className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-widest font-medium">Soggetti ammessi</span>
          </div>
          <ul className="space-y-1.5">
            {AMMESSI.map((it) => (
              <li key={it.title} className="flex gap-2 text-sm">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
                <span className="text-stone-700"><span className="font-medium text-stone-800">{it.title}</span>
                  {it.desc && <span className="text-stone-500"> — {it.desc}</span>}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="flex items-center gap-2 text-rose-700 mb-2">
            <Ban className="w-4 h-4" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-widest font-medium">Enti esclusi (Art. 34)</span>
          </div>
          <ul className="space-y-1.5">
            {ESCLUSI.map((it) => (
              <li key={it.title} className="flex gap-2 text-sm">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-rose-500 shrink-0" />
                <span className="text-stone-700">{it.title}</span>
              </li>
            ))}
          </ul>
        </div>
        <p className="text-xs text-stone-400">
          Glossario completo e tipologie ETS/Imprese Impatto nella pagina <span className="font-medium text-stone-600">Ammissibilità</span> del menu.
        </p>
      </div>
    </DialogContent>
  </Dialog>
);
